import { Component, ContentChild, Input, ViewChild, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { DatePickerComponent } from '../../date-picker/date-picker.component';
import { TimePickerComponent } from '../../date-picker/time-picker.component';
import { AbstractDelegatingControlValueAccessor } from '../abstract-delegating-control-value-accessor';

const FORM_INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FormInputDateComponent),
    multi: true
};

const FORM_INPUT_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => FormInputDateComponent),
    multi: true
};

@Component({
    selector: 'common-form-date-input',
    template: ` <div class="form-group-inline">
                    <common-date-picker *ngIf="!withTime"></common-date-picker>
                    <common-time-picker *ngIf="withTime"></common-time-picker>
                    <common-form-input-tooltip *ngIf="dataToolTip" [value]="dataToolTip"></common-form-input-tooltip>
                    <ng-template [ngTemplateOutlet]="afterInput"></ng-template>
                </div>`,
    providers: [FORM_INPUT_CONTROL_VALUE_ACCESSOR, FORM_INPUT_VALIDATOR]
})
export class FormInputDateComponent extends AbstractDelegatingControlValueAccessor implements Validator {
    @Input() dataToolTip: string;

    @Input() withTime: boolean = false;

    @ContentChild('afterInput') afterInput;

    @ViewChild(DatePickerComponent) datePicker: DatePickerComponent;

    @ViewChild(TimePickerComponent) timePicker: TimePickerComponent;

    registerOnValidatorChange(fn) {
        this.delegatedInit$.next(() => this.getDelegate().registerOnValidatorChange(fn));
    }

    validate(c) {
        return this.getDelegate() ? this.getDelegate().validate(c) : undefined;
    }

    getDelegate() {
        return this.withTime ? this.timePicker : this.datePicker;
    }
}
